import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { importMacrosResult } from "./macro-import-result";

export const uploadGorgiasMacros = {
  name: "uploadGorgiasMacros" as const,
  input: z.object({
    teamId: zExt.objectId(),
    fileName: z.string(),
    fileContent: z.string(),
    mimeType: z.string(),
  }),
  output: importMacrosResult,
};
